import { useTranslation } from '@crew/modules/i18n'
import { CrewButton } from 'components/elements/crewButton/crewButton'
import { memo, useCallback } from 'react'
import { useTaskDetailRelatedInfoListContext } from '../../taskDetailRelatedInfoList'
import { useShowApiErrors } from 'hooks/useShowApiErrors'
import { useTaskDetailRelatedInfoListToolbar } from './useTaskDetailRelatedInfoListToolbar'

export const TaskDetailRelatedInfoListToolbar = memo(() => {
  const { t } = useTranslation()
  const [showApiErrors] = useShowApiErrors()

  const { generateTaskRelatedInfo, isLoadingGenerateRelatedMutation } =
    useTaskDetailRelatedInfoListToolbar()

  const { displayState, setDisplayState } =
    useTaskDetailRelatedInfoListContext()

  // 表示制御
  const showRelatedInfoTable = displayState === 'relatedInfo'

  // 「AIで関連情報を検索する」ボタンをクリックしたときの処理
  const handleFindRelatedInfoButtonClick = useCallback(async () => {
    try {
      // 表示を検索中に切り替え
      setDisplayState('searching')
      // 生成APIを呼び出し
      await generateTaskRelatedInfo()
    } catch (err) {
      setDisplayState('relatedInfo')
      showApiErrors(err)
    }
  }, [generateTaskRelatedInfo, setDisplayState, showApiErrors])

  return (
    <div className="flex justify-between items-center p-2.5">
      {/* 「AIで関連情報を探す」ボタン */}
      {showRelatedInfoTable && (
        <CrewButton
          id="task-detail-related-info-list-toolbar-find-related-info-button"
          type="primary"
          className="ml-auto"
          text={t('action.findRelatedInformationWithAI')}
          onClick={handleFindRelatedInfoButtonClick}
          disabled={isLoadingGenerateRelatedMutation}
        />
      )}
    </div>
  )
})
